const state = {
    fields: [],
    submitEndpoint: '',
    categoriesEndpoint: '',
    apiKey: '',
    arrowRight: '',
    operation: '',
    message: {
        success: false,
        message: 'Något gick fel. Försök igen.'
    },
    loading: false,
    showMessage: false,
    formType: '',
    uploadSvg: null,
    arrowSvg: '',
    locationSvg: '',
}

export default state;